export const STORAGE_DIRECTORIES = {
    LECTORS_IMAGES: 'images/lectors',
    SEMINAR_IMAGES: 'images/seminars',
    GALLERY: 'images/gallery',
    AVIZ: 'files/aviz'
}